(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  function init() {
    var section = document.querySelector('[data-product-section]');
    if (!section || section.dataset.ready) return;
    section.dataset.ready = 'true';

    var jsonEl = document.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var mainImg = section.querySelector('.gallery__main img');
    var thumbs = section.querySelectorAll('[data-thumb]');

    var mainBox = section.querySelector('[data-gallery-main]');

    function showMedia(src, srcset, mediaId) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      thumbs.forEach(function (t) {
        var match = String(t.dataset.mediaId) === String(mediaId);
        t.setAttribute('aria-current', match ? 'true' : 'false');
        if (match && mainBox && t.dataset.zoom) {
          mainBox.dataset.zoom = t.dataset.zoom;
          mainBox.dataset.mediaId = t.dataset.mediaId;
        }
      });
    }

    setupZoom(mainBox);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.mediaId);
      });
    });

    var form = document.getElementById('ProductForm');
    if (!form || !product) return;

    var master = form.querySelector('[data-master-select]');
    var optionSelects = form.querySelectorAll('[data-option-index]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var button = form.querySelector('[data-add-button]');
    var buttonText = form.querySelector('[data-add-text]');
    var status = form.querySelector('[data-status]');
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function findVariant() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
      return product.variants.find(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        button.disabled = true;
        buttonText.textContent = 'Unavailable';
        if (status) status.textContent = 'That combination is unavailable.';
        return;
      }

      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (status) status.textContent = variant.available ? '' : 'This option is sold out.';

      // Price is written first, then the change event fires, so the options app
      // can add its personalization price on top ("$29.00 + $3.00").
      if (master.value !== String(variant.id)) {
        master.value = String(variant.id);
        master.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (variant.featured_media) {
        var thumb = section.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) showMedia(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.mediaId);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', update);
    });
  }

  /* Image zoom: hover to magnify and/or click or tap to open full size (set in the product section) */
  function setupZoom(box) {
    if (!box) return;
    var openBtn = box.querySelector('[data-gallery-open]');
    var dialog = document.querySelector('[data-lightbox]');
    var dataEl = document.querySelector('[data-gallery-json]');
    if (!openBtn) return;
    var items = [];
    try { items = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { items = []; }

    var mode = box.dataset.zoomMode || 'click';
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var layer = box.querySelector('[data-zoom-layer]');

    // Hover to magnify (mouse/trackpad only)
    if ((mode === 'hover' || mode === 'both') && finePointer && layer) {
      var loadedFor = '';
      box.addEventListener('mouseenter', function () {
        if (loadedFor !== box.dataset.zoom) {
          loadedFor = box.dataset.zoom;
          layer.style.backgroundImage = 'url("' + box.dataset.zoom + '")';
        }
        box.classList.add('is-zooming');
      });
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
        layer.style.backgroundPosition = x + '% ' + y + '%';
      });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-zooming'); });
    }

    // In "Hover to magnify" mode, a mouse click does nothing. Taps and the keyboard still open the full-size view.
    function clickAllowed(e) {
      if (mode !== 'hover') return true;
      if (!finePointer) return true;
      return e && e.detail === 0;
    }

    if (!dialog || typeof dialog.showModal !== 'function' || !items.length) {
      // Older browsers: open the large image in a new tab
      openBtn.addEventListener('click', function (e) { if (clickAllowed(e)) window.open(box.dataset.zoom, '_blank', 'noopener'); });
      return;
    }

    var img = dialog.querySelector('[data-lightbox-img]');
    var count = dialog.querySelector('[data-lightbox-count]');
    var prev = dialog.querySelector('[data-lightbox-prev]');
    var next = dialog.querySelector('[data-lightbox-next]');
    var index = 0;

    function show(i) {
      index = (i + items.length) % items.length;
      img.src = items[index].src;
      img.alt = items[index].alt || '';
      if (count) count.textContent = (index + 1) + ' of ' + items.length;
    }
    function close() { dialog.close(); }

    openBtn.addEventListener('click', function (e) {
      if (!clickAllowed(e)) return;
      box.classList.remove('is-zooming');
      var id = String(box.dataset.mediaId);
      var start = 0;
      items.forEach(function (it, i) { if (String(it.id) === id) start = i; });
      show(start);
      dialog.showModal();
      document.body.classList.add('lightbox-open');
    });
    dialog.addEventListener('close', function () {
      document.body.classList.remove('lightbox-open');
      openBtn.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', close);
    dialog.querySelector('.lightbox__frame').addEventListener('click', function (e) {
      if (e.target === e.currentTarget || e.target === img) close();
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dialog.addEventListener('keydown', function (e) {
      if (items.length < 2) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    // Swipe between images on touch screens
    var startX = null;
    dialog.addEventListener('touchstart', function (e) { if (e.touches.length === 1) startX = e.touches[0].clientX; }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (startX === null || items.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
